module.exports = __webpack_public_path__ + "img/step-five-icon.fef31c64.jpg";